import { api } from "@/lib/api"
import { AnalyticsChart } from "./analytics-chart"

export function LiveChatChart() {
	const liveChatChartQuery = api.analytics.liveChatChart.useQuery({})

	return (
		<AnalyticsChart
			title="Live Chat Sessions"
			data={liveChatChartQuery.data}
			isLoading={liveChatChartQuery.isLoading}
		/>
	)
}
